var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 9.97458C9.67305 9.97458 9.00005 9.25899 9.00005 8.37965C9.00005 7.5003 9.67305 6.78471 10.5 6.78471C11.327 6.78471 12 7.5003 12 8.37965C12 9.25899 11.327 9.97458 10.5 9.97458ZM10.5 4.65813C8.57005 4.65813 7.00005 6.32749 7.00005 8.37964C7.00005 10.4318 8.57005 12.1012 10.5 12.1012C12.43 12.1012 14 10.4318 14 8.37964C14 6.32749 12.43 4.65813 10.5 4.65813ZM10.7189 13.6933C6.41287 13.7996 3.60387 9.8835 2.67188 8.37469C3.69788 6.66811 6.28187 3.17413 10.2799 3.06568C14.5689 2.94978 17.3939 6.87545 18.3259 8.38426C17.3009 10.0908 14.7159 13.5848 10.7189 13.6933ZM20.3678 7.85076C19.7297 6.66838 16.2057 0.7416 10.2297 0.940435C4.70175 1.0893 1.48675 6.26752 0.63275 7.85076C0.45575 8.17826 0.45575 8.58124 0.63275 8.90874C1.26175 10.0752 4.66175 15.8223 10.5247 15.8223C10.6067 15.8223 10.6888 15.8212 10.7708 15.8191C16.2977 15.6691 19.5138 10.492 20.3678 8.90874C20.5438 8.58124 20.5438 8.17826 20.3678 7.85076Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.0166530d3b24550366baec4747a0f304.svg";
export { ForwardRef as ReactComponent };